
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/UserDocs/QuickStart",
      function () {
        return require("private-next-pages/docs/UserDocs/QuickStart.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/UserDocs/QuickStart"])
      });
    }
  